import React, { useEffect, useState } from 'react';
import Artist_navbar from '../ArtisitPages/Artist_navbar';
import Sidebar from '../../components/Sidebar';
import './CreateProduct.css';
import { useSelector } from 'react-redux';
import { makeAuthenticatedGETRequest, makeAuthenticatedPOSTRequest, makeAuthenticatedDELETERequest } from '../services/serverHelper';
import { productPoints } from '../services/apis';
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import { purpose } from './ProductList';
import { Link } from 'react-router-dom';


const CreateProduct = () => {

  const [products, setProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');
  const [subcategoryFilter, setSubcategoryFilter] = useState('');
  const [artformFilter, setArtformFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [sortBy, setSortBy] = useState('-createdAt');
  const [deleteLoading, setDeleteLoading] = useState(false);
  const {accessToken} = useSelector(state => state.auth)
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  /**
   * Handle product deletion
   */
  const handleDeleteProduct = async () => {
    if (!selectedProduct) return;

    try {
      setDeleteLoading(true);
      await makeAuthenticatedDELETERequest(
        `${productPoints.DELETE_PRODUCTS_API}/${selectedProduct._id}`,
        accessToken
      );

      // Remove deleted product from list
      setAllProducts(allProducts.filter(p => p._id !== selectedProduct._id));
      setProducts(products.filter(p => p._id !== selectedProduct._id));
      setTotalItems(prev => Math.max(0, prev - 1));

      // Close modal
      setShowDeleteModal(false);
      setSelectedProduct(null);

      // Show success message
      alert('Product deleted successfully');
    } catch (err) {
      console.error('Error deleting product:', err);
      alert('Failed to delete product. Please try again.');
    } finally {
      setDeleteLoading(false);
    }
  };

  /**
   * Handle status toggle (activate/deactivate)
   */
  // const handleToggleStatus = async (productId, currentStatus) => {
  //   try {
  //     const token = localStorage.getItem('authToken');
  //     if (!token) {
  //       alert('Authentication required. Please log in.');
  //       return;
  //     }

  //     const response = await axios.put(
  //       `${API_BASE_URL}/api/products/${productId}`,
  //       {
  //         isActive: !currentStatus,
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     // Update product in list
  //     setProducts(
  //       products.map(p =>
  //         p._id === productId ? { ...p, isActive: !currentStatus } : p
  //       )
  //     );

  //     alert(
  //       `Product ${!currentStatus ? 'activated' : 'deactivated'} successfully`
  //     );
  //   } catch (err) {
  //     console.error('Error toggling product status:', err);
  //     alert('Failed to update product status. Please try again.');
  //   }
  // };

  /**
   * Handle opening delete confirmation modal
   */
  const openDeleteModal = (product) => {
    setSelectedProduct(product);
    setShowDeleteModal(true);
  };

  /**
   * Handle closing delete confirmation modal
   */
  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedProduct(null);
  };

  /**
   * Handle search form submission
   */
  const handleSearch = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    // fetchProducts(1, searchTerm, categoryFilter, statusFilter);
  };

  const updateFilter = (key, value) => {
    const params = new URLSearchParams(searchParams.toString());
    if (value && value !== '') params.set(key, String(value));
    else params.delete(key);
    // reset page when changing filters
    if (key !== 'page') params.set('page', '1');
    setSearchParams(params);
  };

  const resetFilters = () => {
    setSearchTerm('');
    setCategoryFilter('');
    setSubcategoryFilter('');
    setArtformFilter('');
    setStatusFilter('all');
    setSortBy('-createdAt');
    setItemsPerPage(10);
    setCurrentPage(1);
    setSearchParams(new URLSearchParams());
  };

  /**
   * Handle filter changes
   */
  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    if (name === 'search') {
      setSearchTerm(value);
      setCurrentPage(1);
      updateFilter('search', value);
    } else if (name === 'category') {
      setCategoryFilter(value);
      setCurrentPage(1);
      updateFilter('category', value);
      // reset dependent filters
      setSubcategoryFilter('');
      setArtformFilter('');
      updateFilter('subcategory', '');
      updateFilter('artform', '');
      // fetchProducts(1, searchTerm, value, statusFilter);
    } else if (name === 'status') {
      setStatusFilter(value);
      setCurrentPage(1);
      updateFilter('status', value);
      // fetchProducts(1, searchTerm, categoryFilter, value);
    }
  };

  /**
   * Handle pagination
   */
  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= Math.ceil(totalItems / itemsPerPage)) {
      setCurrentPage(newPage);
      updateFilter('page', newPage);
      // fetchProducts(newPage, searchTerm, categoryFilter, statusFilter);
    }
  };

  /**
   * Handle items per page change
   */
  const handleItemsPerPageChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setItemsPerPage(newLimit);
    setCurrentPage(1);
    updateFilter('limit', newLimit);
  };

  /**
   * Handle sort change
   */
  const handleSortChange = (e) => {
    setSortBy(e.target.value);
    setCurrentPage(1);
    updateFilter('sort', e.target.value);
  };

  // initialize state from URL params
  useEffect(() => {
    const sp = Object.fromEntries(searchParams.entries());
    if (sp.search) setSearchTerm(sp.search);
    if (sp.category) setCategoryFilter(sp.category);
    if (sp.subcategory) setSubcategoryFilter(sp.subcategory);
    if (sp.artform) setArtformFilter(sp.artform);
    if (sp.status) setStatusFilter(sp.status);
    if (sp.sort) setSortBy(sp.sort);
    if (sp.limit) setItemsPerPage(parseInt(sp.limit));
    if (sp.page) setCurrentPage(parseInt(sp.page));
  }, [searchParams.toString()]);

  const handleAddProduct = ()=>{ 
    navigate("/Artist_profile?section=product&action=add")
   }

  // Calculate pagination
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage + 1;
  const endIndex = Math.min(currentPage * itemsPerPage, totalItems);

  const fetchArtistProducts = async()=>{
    const response = await makeAuthenticatedGETRequest(
      productPoints.FETCH_ARTIST_PRODUCT,
      accessToken
    );
    if(response.statusCode === 200){
      console.log(response.data);
      // store full list and apply client-side filters/pagination
      setAllProducts(response.data);
      setProducts(response.data);
      setLoading(false);
    }else{
      toast.error("Unable to fetch products");
    }
  }

  // Apply filters, sorting and pagination on client-side for artist products
  const applyFilters = () => {
    let filtered = Array.isArray(allProducts) ? [...allProducts] : [];

    // Search
    if (searchTerm && searchTerm.trim() !== '') {
      const s = searchTerm.trim().toLowerCase();
      filtered = filtered.filter(p => {
        return (
          (p.title && p.title.toLowerCase().includes(s)) ||
          (p.description && p.description.toLowerCase().includes(s))
        );
      });
    }

    // Category
    if (categoryFilter && categoryFilter !== '') {
      // In this schema `title` stores the high-level category
      filtered = filtered.filter(p => (p.title || '').toLowerCase() === categoryFilter.toLowerCase());
    }

    // Subcategory (maps to product.category)
    if (subcategoryFilter && subcategoryFilter !== '') {
      filtered = filtered.filter(p => (p.category || '').toLowerCase() === subcategoryFilter.toLowerCase());
    }

    // Artform (maps to product.subCategory)
    if (artformFilter && artformFilter !== '') {
      filtered = filtered.filter(p => (p.subCategory || '').toLowerCase() === artformFilter.toLowerCase());
    }

    // Status
    if (statusFilter && statusFilter !== 'all') {
      if (statusFilter === 'active') filtered = filtered.filter(p => p.isActive === true);
      else if (statusFilter === 'inactive') filtered = filtered.filter(p => p.isActive === false);
    }

    // Sorting
    const sortKey = sortBy || '-createdAt';
    const desc = sortKey.startsWith('-');
    const key = desc ? sortKey.slice(1) : sortKey;

    const getValue = (obj, path) => {
      try {
        return path.split('.').reduce((acc, k) => acc && acc[k], obj);
      } catch (e) {
        return undefined;
      }
    };

    filtered.sort((a, b) => {
      const va = getValue(a, key);
      const vb = getValue(b, key);

      // handle dates
      if (key === 'createdAt') {
        const da = new Date(va).getTime() || 0;
        const db = new Date(vb).getTime() || 0;
        return desc ? db - da : da - db;
      }

      const na = typeof va === 'number' ? va : (va ? va : 0);
      const nb = typeof vb === 'number' ? vb : (vb ? vb : 0);
      if (na < nb) return desc ? 1 : -1;
      if (na > nb) return desc ? -1 : 1;
      return 0;
    });

    // Pagination
    const total = filtered.length;
    setTotalItems(total);

    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    const paged = filtered.slice(start, end);

    setProducts(paged);
  };

  useEffect(()=>{
    fetchArtistProducts();
  }, [])

  // re-apply filters when any controlling value changes
  useEffect(() => {
    if (!loading) applyFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allProducts, searchTerm, categoryFilter, subcategoryFilter, artformFilter, statusFilter, sortBy, currentPage, itemsPerPage, loading]);

  return (
    <>
      <Artist_navbar />
      <div className="create-product-layout">
        <Sidebar />
        <div className='dashboard-content'>
            <div className="artist-products-page">
            <div className="products-header">
                <div className='products-heading'>
                <h2>Production Management</h2>
                </div>
            </div>

            {/* Search and Filter Section */}
            <div className="filters-section-admin-products">
                <form onSubmit={handleSearch} className="search-form">
                <div className="form-group">
                    <input
                    type="text"
                    name="search"
                    placeholder="Search by product name or description..."
                    value={searchTerm}
                    onChange={handleFilterChange}
                    className="search-input"
                    />
                    <button type="submit" className="search-button">
                        <span>🔍</span> Search
                    </button>
                </div>
                </form>

                <div className="filters-row">
                <div className="filter-group">
                    <label htmlFor="category-filter">Category:</label>
                    <select
                    id="category-filter"
                    name="category"
                    value={categoryFilter}
                    onChange={handleFilterChange}
                    className="filter-select"
                    >
                    <option value="">All Categories</option>
                    {purpose.map((p) => (
                      <option key={p.category} value={p.category}>{p.category}</option>
                    ))}
                    </select>
                </div>

                <div className="filter-group">
                    <label htmlFor="status-filter">Status:</label>
                    <select
                    id="status-filter"
                    name="status"
                    value={statusFilter}
                    onChange={handleFilterChange}
                    className="filter-select"
                    >
                    <option value="all">All Status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                    </select>
                </div>

                <div className="filter-group">
                    <label htmlFor="subcategory-filter">Sub Category:</label>
                    <select
                      id="subcategory-filter"
                      name="subcategory"
                      value={subcategoryFilter}
                      onChange={(e)=>{ setSubcategoryFilter(e.target.value); updateFilter('subcategory', e.target.value); setCurrentPage(1); }}
                      className="filter-select"
                    >
                      <option value="">All Subcategories</option>
                      {(() => {
                        const catObj = purpose.find(p => p.category === categoryFilter);
                        return catObj?.subcategories.map(s => (
                          <option key={s.name} value={s.name}>{s.name}</option>
                        ));
                      })()}
                    </select>
                </div>

                <div className="filter-group">
                    <label htmlFor="artform-filter">Art Form:</label>
                    <select
                      id="artform-filter"
                      name="artform"
                      value={artformFilter}
                      onChange={(e)=>{ setArtformFilter(e.target.value); updateFilter('artform', e.target.value); setCurrentPage(1); }}
                      className="filter-select"
                    >
                      <option value="">All Art Forms</option>
                      {(() => {
                        const catObj = purpose.find(p => p.category === categoryFilter);
                        const subObj = catObj?.subcategories.find(s => s.name === subcategoryFilter);
                        return subObj?.artForms.map(a => (
                          <option key={a} value={a}>{a}</option>
                        ));
                      })()}
                    </select>
                </div>

                <div className="filter-group">
                    <label htmlFor="sort-filter">Sort By:</label>
                    <select
                    id="sort-filter"
                    value={sortBy}
                    onChange={handleSortChange}
                    className="filter-select"
                    >
                    <option value="-createdAt">Newest First</option>
                    <option value="createdAt">Oldest First</option>
                    <option value="-pricing.amount">Price: High to Low</option>
                    <option value="pricing.amount">Price: Low to High</option>
                    <option value="-stats.views">Most Viewed</option>
                    </select>
                </div>

                <div className="filter-group">
                    <label htmlFor="items-per-page">Items per page:</label>
                    <select
                    id="items-per-page"
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                    className="filter-select"
                    >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    </select>
                </div>
                <div className="filter-group" style={{ alignSelf: 'flex-end' }}>
                    <button type="button" className="filter-reset-button" onClick={resetFilters} style={{ padding: '10px 16px', borderRadius: '8px', backgroundColor: '#f5f5f5', border: '1px solid #ccc', cursor: 'pointer' }}>
                      Reset Filters
                    </button>
                </div>
                </div>

            </div>
            <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                <Link to="/marketplace" style={{display:"flex", width:"20%", borderRadius:"10px", padding:"10px", textDecoration:"none", justifyContent:"center", alignItems:"center", backgroundColor:"#ad2f3b", color:"white"}}>
                    Go to Market
                </Link>
                <div className='filters-row' style={{marginTop:"20px", marginBottom:"20px", justifySelf:"flex-end"}}>
                    <button onClick={handleAddProduct} style={{display:"flex", width:"100%", borderRadius:"10px", padding:"10px", justifyContent:"center", alignItems:"center", backgroundColor:"#ad2f3b", color:"white"}}>
                        <span>+</span> Add
                    </button>
                </div>
            </div>

            {/* Error Message */}
            {error && (
                <div className="error-banner">
                <span>⚠️</span> {error}
                </div>
            )}

            {/* Loading State */}
            {loading ? (
                <div className="loading-container">
                <div className="spinner"></div>
                <p>Loading products...</p>
                </div>
            ) : products.length === 0 ? (
                // Empty State
                <div className="empty-state">
                <div className="empty-icon">📦</div>
                <h2>No Products Found</h2>
                <p>
                    {searchTerm || categoryFilter || statusFilter !== 'all'
                    ? 'Try adjusting your search or filter criteria'
                    : 'No products available at this time'}
                </p>
                </div>
            ) : (
                <>
                {/* Products Table */}
                <div className="table-container">
                    <table className="products-table">
                    <thead>
                        <tr>
                        <th>Product Name</th>
                        <th>Category</th>
                        <th>Price</th>
                        <th>Views</th>
                        <th>Rating</th>
                        <th>Status</th>
                        <th>Created Date</th>
                        <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {products.map((product, index) => (
                        <tr key={product._id} className={index % 2 === 0 ? 'zebra-odd' : 'zebra-even'}>
                            <td className="product-name-cell">
                            <div className="product-name-content">
                                {product.video?.thumbnail && (
                                <img
                                    src={product.video.thumbnail}
                                    alt={product.title}
                                    className="product-thumbnail"
                                />
                                )}
                                <div className="product-info">
                                <strong>{product.title}</strong>
                                <small>{product.language}</small>
                                </div>
                            </div>
                            </td>
                            <td>
                            <span className="category-badge">{product.category}</span>
                            </td>
                            <td className="price-cell">
                            ₹{product.pricing?.amount?.toFixed(2) || '0.00'}
                            </td>
                            <td className="views-cell">{product.stats?.views || 0}</td>
                            <td className="rating-cell">
                            <span className="rating">
                                {'⭐'.repeat(Math.round(product.stats?.rating || 0))}
                                {product.stats?.rating
                                ? ` ${product.stats.rating.toFixed(1)}`
                                : ' No ratings'}
                            </span>
                            </td>
                            <td>
                            <button
                                className={`status-toggle ${
                                product.isActive ? 'active' : 'inactive'
                                }`}
                                // onClick={() =>
                                // // handleToggleStatus(product._id, product.isActive)
                                // }
                                title={product.isActive ? 'Click to deactivate' : 'Click to activate'}
                            >
                                {product.isActive ? 'Active' : 'Inactive'}
                            </button>
                            </td>
                            <td className="date-cell">
                            {new Date(product.createdAt).toLocaleDateString()}
                            </td>
                            <td className="actions-cell">
                            <div className="actions-group">
                                {/* <button
                                className="action-btn view-btn"
                                title="View product details"
                                onClick={() => {
                                    // Navigate to product detail page or show details modal
                                    console.log('View product:', product._id);
                                }}
                                >
                                👁️ View
                                </button> */}
                                {/* <button
                                className="action-btn edit-btn"
                                title="Edit product"
                                onClick={() => {
                                    // Navigate to edit page or show edit modal
                                    console.log('Edit product:', product._id);
                                }}
                                >
                                ✏️ Edit
                                </button> */}
                                <button
                                    className="action-btn delete-btn"
                                    title="Delete product"
                                    onClick={() => openDeleteModal(product)}
                                    >
                                    🗑️ Delete
                                </button>
                            </div>
                            </td>
                        </tr>
                        ))}
                    </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination-section">
                    <div className="pagination-info">
                    Showing <strong>{startIndex}</strong> to <strong>{endIndex}</strong> of{' '}
                    <strong>{totalItems}</strong> products
                    </div>

                    <div className="pagination-controls">
                    <button
                        className="pagination-btn"
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        ← Previous
                    </button>

                    <div className="page-numbers">
                        {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                        (page) => {
                            if (
                            page === 1 ||
                            page === totalPages ||
                            (page >= currentPage - 1 && page <= currentPage + 1)
                            ) {
                            return (
                                <button
                                key={page}
                                className={`page-number ${
                                    page === currentPage ? 'active' : ''
                                }`}
                                onClick={() => handlePageChange(page)}
                                >
                                {page}
                                </button>
                            );
                            } else if (
                            page === currentPage - 2 ||
                            page === currentPage + 2
                            ) {
                            return (
                                <span key={page} className="page-ellipsis">
                                ...
                                </span>
                            );
                            }
                            return null;
                        }
                        )}
                    </div>

                    <button
                        className="pagination-btn"
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next →
                    </button>
                    </div>
                </div>
                </>
            )}

            {/* Delete Confirmation Modal */}
            {showDeleteModal && (
                <div className="modal-overlay" onClick={closeDeleteModal}>
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                    <h2>Delete Product</h2>
                    <button
                        className="modal-close-btn"
                        onClick={closeDeleteModal}
                    >
                        ✕
                    </button>
                    </div>

                    <div className="modal-body">
                    <div className="warning-icon">⚠️</div>
                    <p>
                        Are you sure you want to delete{' '}
                        <strong>"{selectedProduct?.title}"</strong>?
                    </p>
                    <p className="warning-text">
                        This action cannot be undone. The product will be permanently
                        removed from the marketplace.
                    </p>
                    </div>

                    <div className="modal-footer">
                    <button
                        className="modal-btn cancel-btn"
                        onClick={closeDeleteModal}
                        disabled={deleteLoading}
                    >
                        Cancel
                    </button>
                    <button
                        className="modal-btn delete-confirm-btn"
                        onClick={handleDeleteProduct}
                        disabled={deleteLoading}
                    >
                        {deleteLoading ? 'Deleting...' : 'Delete Product'}
                    </button>
                    </div>
                </div>
                </div>
            )}
            </div>
        </div>
      </div>
    </>
  );
};

export default CreateProduct;